import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { useContactContext } from "@/contexts/contact";
import { useTrackingLeadFormError } from "@/hooks";
import { getFeaturesEnabled } from "@/utils/getFeaturesEnabled";
import { Box } from "@gemini/core";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { SuggestPriceButton } from "../Buttons/SuggestPriceButton";
import { ContactFormPlato } from "./ContactFormPlato";
import { ContactFormSubmit } from "./ContactFormSubmit";
import { FormFieldsSection } from "./FormFieldsSection";
import { LegalText } from "./LegalText";
import { OwnerFlag } from "./OwnerFlag";
import { SaveSearchOptIn } from "./SaveSearchOptIn";
import { ShareProfile } from "./SeekerProfile";
import { contactFormTestId } from "./constants";
import { useIsSavedSearchEnabled } from "../hooks/useIsSavedSearchEnabled";
import { useIsSimplifiedForm } from "../hooks/useIsSimplifiedForm";
import { useCombinedUserData } from "../hooks/useCombinedUserData";
import { SaveSearchOptInDE } from "./SaveSearchOptInDE";
export const ContactForm = ({ onSubmit, loading, contactFormDatas, isModal, avZone, }) => {
    const trackLeadFormKo = useTrackingLeadFormError();
    const { isOpen, userData, userCookieData } = useContactContext();
    const [, setValidationErrors] = useState(undefined);
    const onSubmitError = (errors) => {
        setValidationErrors(errors);
        Object.values(errors).forEach((error) => {
            trackLeadFormKo({ additionalProps: { av_error_code: error.message } });
        });
    };
    const { handleSubmit, control, reset, getValues } = useFormContext();
    const { displayOwnerFlag } = contactFormDatas;
    const [hasSearchParameters, setHasSearchParameters] = useState(false);
    useEffect(() => {
        var _a;
        const hasSearchParameters = 
        // @ts-ignore
        // eslint-disable-next-line no-restricted-globals
        ((_a = new URL(window.location.href).searchParams.get("search")) === null || _a === void 0 ? void 0 : _a.length) > 0;
        setHasSearchParameters(hasSearchParameters);
    }, []);
    const isSavedSearchTestEnabled = useIsSavedSearchEnabled();
    const { savedSearchOptIn } = getFeaturesEnabled();
    const isSaveSearchOptInEnabledDE = isSavedSearchTestEnabled && hasSearchParameters;
    const isSaveSearchOptInEnabledFR = savedSearchOptIn && hasSearchParameters;
    const defaultNewsletterPreference = isSaveSearchOptInEnabledDE
        ? "email"
        : "email-sms";
    const combinedUserData = useCombinedUserData(userData !== null && userData !== void 0 ? userData : undefined);
    const isSimplifiedContactForm = useIsSimplifiedForm();
    useEffect(() => {
        const currentValue = getValues("newsletterOptInPreference");
        const optOutValue = getValues("newsletterOptout");
        reset(Object.assign(Object.assign(Object.assign({}, getValues()), (isSimplifiedContactForm
            ? combinedUserData
            : userData !== null && userData !== void 0 ? userData : userCookieData)), { newsletterOptInPreference: isSaveSearchOptInEnabledDE
                ? "email"
                : currentValue || defaultNewsletterPreference, newsletterOptout: optOutValue || false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData, userCookieData, reset, isOpen, getValues]);
    return (_jsx(_Fragment, { children: _jsxs(Box, { testId: contactFormTestId, as: "form", onSubmit: handleSubmit(onSubmit, onSubmitError), children: [_jsx(FormFieldsSection, { contactFormDatas: contactFormDatas, 
                    // @ts-ignore
                    tracking: { avZone: avZone } }), _jsx(ShareProfile, {}), _jsxs(Box, { children: [_jsx(OwnerFlag, { control: control, required: false, testId: contactFormTestId, displayOwnerFlag: displayOwnerFlag }), isSaveSearchOptInEnabledDE || isSaveSearchOptInEnabledFR ? (_jsx(Box, { children: isSaveSearchOptInEnabledDE ? (_jsx(SaveSearchOptInDE, { control: control, testId: contactFormTestId })) : (_jsx(SaveSearchOptIn, { control: control, required: false, testId: contactFormTestId, isSaveSearchOptInEnabled: isSaveSearchOptInEnabledFR })) })) : null] }), _jsxs(Box, { paddingVertical: "spacing.16", children: [_jsx(ContactFormSubmit, { loading: loading }), _jsx(ContactFormPlato, { showDivider: false, 
                            // @ts-ignore
                            tracking: { avZone: avZone } }), _jsx(SuggestPriceButton, { isModal: isModal })] }), _jsx(LegalText, { isModal: isModal })] }) }));
};
